import { Injectable } from "@angular/core";

@Injectable()
export class ValidatorService {

    isRequired(element) {
        if (element.value) {
            return "";
        } else {
            return "required!";
        }
    }

    isEmail(element) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(element.value)) {
            return "Invalid email address!";
        }
        return "";
    }

    isPhone(element) {
        if (element.value != 987) {
            return "Invalid Phone number";
        }
        return ""
    }

    betweenDate(element, startDate, endDate) {
        if (element.value < startDate || element.value > endDate) {
            return "This field should be between " + startDate + " and " + endDate;
        } else {
            return true;
        }
    }

    // custom cell validations
    // checkbox min characters selection
    textBoxMinValidation(cell, validation) {
        if (cell.cellInputHTMLComponentJSONList[0].value) {
            if (cell.cellInputHTMLComponentJSONList[0].value.length < validation.value) {
                return "Value should not be less than " + validation.value;
            }
        }
    }

    // checkbox max characters selection
    textBoxMaxValidation(cell, validation) {
        if (cell.cellInputHTMLComponentJSONList[0].value) {
            if (cell.cellInputHTMLComponentJSONList[0].value.length > validation.value) {
                return "Value should not be greater than " + validation.value;
            }
        }
    }

    // checkbox minimum selection
    dateMinValidation(cell, validation) {
        var validationDate = validation.value;
        var validationDateArray = validationDate.split("/");
        var newValidationDate = validationDateArray[1] + '/' + validationDateArray[0] + '/' + validationDateArray[2];
        var inputDate = cell.cellInputHTMLComponentJSONList[0].value;
        var inputDateArray = inputDate.split("/");
        var newinputDate = inputDateArray[1] + '/' + inputDateArray[0] + '/' + inputDateArray[2];
        if (newinputDate < newValidationDate) {
            return "date should not be before " + validation.value;
        }
    }

    // date maximum selection
    dateMaxValidation(cell, validation) {
        var validationDate = validation.value;
        var validationDateArray = validationDate.split("/");
        var newValidationDate = validationDateArray[1] + '/' + validationDateArray[0] + '/' + validationDateArray[2];
        var inputDate = cell.cellInputHTMLComponentJSONList[0].value;
        var inputDateArray = inputDate.split("/");
        var newinputDate = inputDateArray[1] + '/' + inputDateArray[0] + '/' + inputDateArray[2];
        if (newinputDate > newValidationDate) {
            return "date should not be after " + validation.value;
        }
    }

    // checkbox minimum selection
    selectMinValidation(cell, validation) {
        if (cell.selectedCheckBoxes) {
            if (cell.selectedCheckBoxes.length < validation.value) {
                return "Alteast " + validation.value + " checkbox should be selected";
            } else {
                return "";
            }
        } else {
            return "Alteast " + validation.value + " checkbox should be selected";
        }
    }

    // checkbox maximum selection
    selectMaxValidation(cell, validation) {
        if (cell.selectedCheckBoxes) {
            if (cell.selectedCheckBoxes.length > validation.value) {
                return "Almost " + validation.value + " checkbox should be selected";
            } else {
                return "";
            }
        } else {
            return "Alteast " + validation.value + " checkbox should be selected";
        }
    }

    // function called by welcome page for normal validations
    /* will return elm with validation messages if validation fails,
        otherwise false will be returned */
    validate(elm) {
        var error = false;
        // normal validations
        error = this.validateRequiredAndEmail(elm, error);
        if (error) {
            return elm;
        }

        // custom validations- removed for welcome page
        // elm.forEach(htmlComponent => {
        //     htmlComponent['inputHTMLComponentJSONList'].forEach(element => {
        //         var msg = "";
        //         if (element.validation) {
        //             element.validation.forEach(validation => {
        //                 switch (validation.type) {
        //                     case "phone":
        //                         msg = this.isPhone(element);
        //                         break;
        //                     case "daterange":
        //                         break;
        //                 }
        //                 if (msg != "") {
        //                     element.errorMessage = msg;
        //                 }
        //                 if (element.errorMessage != "") {
        //                     error = true;
        //                 }
        //             });
        //         }
        //     });
        // });

        if (error == false)
            return false;
        else
            return elm;
    }

    // validation for mandatory and email
    validateRequiredAndEmail(elm, error) {
        elm.forEach(htmlComponent => {
            htmlComponent['inputHTMLComponentJSONList'].forEach(element => {
                var msg = "";
                if (element.viewable && element.mandatory == true && (this.stringValidator(element.value))) {
                    element.errorMessage = "required!";
                    error = true;
                }
                if (element.placeholder) {
                    if ((element.placeholder.indexOf("email") > -1 || element.placeholder.indexOf("Email") > -1) && !(element.value == "" || element.value == null)) {
                        var errorMsg = this.isEmail(element);
                        if (errorMsg != "") {
                            element.errorMessage = errorMsg;
                            error = true;
                        } else {
                            element.errorMessage = undefined;
                        }
                    }
                }
            })
        });
        return error;
    }

    stringValidator(value) {
        var result: Boolean;
        if (value == null || value.trim() == "") {
            result = true;
        }
        return result;
    }

    validateMandatoryAndRequiredOnQuestions(questions) {
        var error = false;
        questions["questionCardResponseJSONList"].forEach(card => {
            if (card.questionTextJSON.questionTextComponentJSON.viewable && card.priviledgeEditable) {
                card["questionColumnJSONList"].forEach(cell => {
                    cell["cellComponentDetailJSONList"].forEach(cellComponentDetail => {
                        cellComponentDetail["cellComponentJSON"]["cellInputHTMLComponentJSONList"].forEach(element => {
                            if (element.mandatory && element.viewable) {
                                if (element.type == 9) {
                                    if (!element.value && element.value != 0) {
                                        cellComponentDetail["cellComponentJSON"].cellErrorMessage = "required!";
                                        error = true;
                                    }
                                }
                                else if (element.type == 5 || element.type == 6 || element.type == 7) {
                                    if (!element.value) {
                                        cellComponentDetail["cellComponentJSON"].cellErrorMessage = "required!";
                                        error = true;
                                    }
                                }
                                else if (element.type == 3) {
                                    if (cellComponentDetail["cellComponentJSON"].selectedDropValue == 0 || cellComponentDetail["cellComponentJSON"].selectedDropValue == "0") {
                                        cellComponentDetail["cellComponentJSON"].cellErrorMessage = "required!";
                                        error = true;
                                    }
                                }
                                else {
                                    if ((cellComponentDetail["cellComponentJSON"].selectedCheckBoxes == null || cellComponentDetail["cellComponentJSON"].selectedCheckBoxes.length == 0) && cellComponentDetail["cellComponentJSON"].selectedRadio == "" && cellComponentDetail["cellComponentJSON"].selectedDropValue == "") {
                                        cellComponentDetail["cellComponentJSON"].cellErrorMessage = "required!";
                                        error = true;
                                    }
                                }
                            }
                        });
                    });
                });
            }
        });
        if (error) {
            return questions;
        } else {
            return false;
        }
    }

    checkingAtLeastOneQuestionIsFilledForSaving(questions) {
        var oneQuestionIsFilled = false;
        questions["questionCardResponseJSONList"].forEach(card => {
            if (card.questionTextJSON.questionTextComponentJSON.viewable && card.priviledgeEditable) {
                card["questionColumnJSONList"].forEach(cell => {
                    cell["cellComponentDetailJSONList"].forEach(cellComponentDetail => {
                        cellComponentDetail["cellComponentJSON"]["cellInputHTMLComponentJSONList"].forEach(element => {
                            if (element.viewable) {
                                if (element.type == 9) {
                                    if (element.value) {
                                        oneQuestionIsFilled = true;
                                    }
                                }
                                else if (element.type == 5 || element.type == 6 || element.type == 7) {
                                    if (element.value) {
                                        oneQuestionIsFilled = true;
                                    }
                                } else {
                                    if ((cellComponentDetail["cellComponentJSON"].selectedCheckBoxes != null && cellComponentDetail["cellComponentJSON"].selectedCheckBoxes != []) || cellComponentDetail["cellComponentJSON"].selectedRadio != 0 || cellComponentDetail["cellComponentJSON"].selectedDropValue != 0) {
                                        oneQuestionIsFilled = true;
                                    }
                                }
                            }
                        });
                    });
                });
            }
        });
        if (oneQuestionIsFilled) {
            return false;
        } else {
            return true;
        }
    }

    // function for validating questions
    /* will return questionPageDetailResponseJSON with updated error messages if validation fails 
    otherwise false will be returned */
    validateCellValidation(questions) {
        var error = false;
        error = this.validateMandatoryAndRequiredOnQuestions(questions);
        if (error) {
            return questions;
        } else {
            questions["questionCardResponseJSONList"].forEach(card => {
                if (card.questionTextJSON.questionTextComponentJSON.viewable && card.priviledgeEditable) {
                    card["questionColumnJSONList"].forEach(cell => {
                        cell["cellComponentDetailJSONList"].forEach(cellComponentDetail => {
                            if (cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"] && cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"].length > 0) {
                                cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = "";
                                for (var i = 0; i < cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"].length; i++) {
                                    switch (cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"][i].selectedValidationLabel) {
                                        case "Min Select":
                                            cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = this.selectMinValidation(cellComponentDetail["cellComponentJSON"], cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"][i]["cellLevelValidationValueMapperJSONList"][0]);
                                            break;
                                        case "Max Select":
                                            cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = this.selectMaxValidation(cellComponentDetail["cellComponentJSON"], cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"][i]["cellLevelValidationValueMapperJSONList"][0]);
                                            break;
                                        case "min char":
                                            cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = this.textBoxMinValidation(cellComponentDetail["cellComponentJSON"], cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"][i]["cellLevelValidationValueMapperJSONList"][0]);
                                            break;
                                        case "max char":
                                            cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = this.textBoxMaxValidation(cellComponentDetail["cellComponentJSON"], cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"][i]["cellLevelValidationValueMapperJSONList"][0]);
                                            break;
                                        case "min date":
                                            cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = this.dateMinValidation(cellComponentDetail["cellComponentJSON"], cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"][i]["cellLevelValidationValueMapperJSONList"][0]);
                                            break;
                                        case "max date":
                                            cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = this.dateMaxValidation(cellComponentDetail["cellComponentJSON"], cellComponentDetail["cellComponentJSON"]["cellValidationJSONList"][i]["cellLevelValidationValueMapperJSONList"][0]);
                                            break;
                                    }
                                    if (cellComponentDetail["cellComponentJSON"]["cellErrorMessage"]) {
                                        error = true;
                                        break;
                                    }
                                }
                            }
                        });
                    });
                }
            });
            if (error) {
                return questions;
            } else {
                return false;
            }
        }
    }

    // validation for column type
    validateColumnValidation(questions) {
        var error = false;

        questions["questionCardResponseJSONList"].forEach(card => {
            if (card.questionTextJSON.questionTextComponentJSON.viewable && card.priviledgeEditable) {
                card["questionColumnJSONList"].forEach(cell => {
                    if (cell["columnValidationJSONList"]) {
                        var validationValue = 0, sliderSumValue = 0;
                        cell["columnValidationJSONList"].forEach(validations => {
                            validations["columnLevelValidationValueMapperJSONList"].forEach(validation => {
                                if (validation.styleClass == "total_slider_value") {
                                    validationValue = validation.value;
                                }
                            });
                        });
                        cell["cellComponentDetailJSONList"].forEach(cellComponentDetail => {
                            if (cellComponentDetail["cellComponentJSON"]["cellInputHTMLComponentJSONList"][0].viewable && cellComponentDetail["cellComponentJSON"]["cellInputHTMLComponentJSONList"][0].Type == 9) {
                                sliderSumValue += cellComponentDetail["cellComponentJSON"]["cellInputHTMLComponentJSONList"][0].value;
                            }
                        });
                        if (validationValue != sliderSumValue) {
                            cell["columnErrorMessage"] = "Slider's total value Should be equal to " + validationValue;
                            error = true;
                        }
                    }
                });
            }
        });
        if (error) {
            return questions;
        } else {
            return false;
        }
    }
}